import {Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import {ImgIcon} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcon';
import {ImgIcons} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcons';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/collapse/Collapse.less');
const cx = classnames.bind(styles);

const animationTime = 300; // ms

export type TargetElement = React.ReactElement<any>;

export interface ICollapseState
{
    isOpen?:boolean;
    height:number;
    isOverflowHidden:boolean;
}

export interface ICollapseProps
{
    className?:string;
    targetClassName?:string;
    contentClassName?:string;
    innerContentClassName?:string;
    withBorders?:boolean;
    withPaddingInContent?:boolean;
    collapseBtnStyle?:React.CSSProperties;
    target:TargetElement;
    defaultIsOpen?:boolean;
    isOpen?:boolean;
    onClick?:(isOpen:boolean, event:React.MouseEvent<HTMLElement>) => void;
}

export class Collapse extends React.Component<ICollapseProps, ICollapseState>
{
    constructor(props:ICollapseProps)
    {
        super(props);
        const isOpen = this._getInitialIsOpenState();
        this.state = {isOpen, height: 0, isOverflowHidden: true};
    }

    private content:HTMLDivElement;

    componentWillReceiveProps({isOpen}:ICollapseProps)
    {
        if( isOpen !== undefined )
        {
            this.setState({
                isOpen,
                height: isOpen ? this.content.clientHeight : 0
            });
        }
    }

    componentDidMount()
    {
        if( this.props.defaultIsOpen )
        {
            // Note: at this moment sizes may not be calculated yet
            this.setState({height: this.content.clientHeight});
        }
    }

    private _getInitialIsOpenState():boolean
    {
        const {defaultIsOpen, isOpen} = this.props;

        if( isOpen !== undefined )
        {
            return isOpen;
        }
        else if( defaultIsOpen !== undefined )
        {
            return defaultIsOpen;
        }
        else
        {
            // closed by default in an uncontrolled usage
            return false;
        }
    }

    @bind
    private _handleCollapseArrowClick(event:React.MouseEvent<HTMLElement>)
    {
        const {isOpen, onClick} = this.props;

        // uncontrolled usage
        if( isOpen === undefined )
        {
            this.setState(({isOpen}) => (
                {
                    isOpen: !isOpen,
                    height: !isOpen ? this.content.clientHeight : 0
                }), () =>
            {
                if( onClick )
                {
                    onClick(this.state.isOpen, event);
                }

                // if( this.state.isOpen )
                // {
                // 	setTimeout(() => this.setState({isOverflowHidden: false}), animationTime);
                // }
                // else
                // {
                // 	this.setState({isOverflowHidden: true});
                // }
            });
        }
        else if( onClick )
        {
            onClick(this.state.isOpen, event);
        }
    };

    public render():JSX.Element
    {
        const {
            className,
            targetClassName,
            contentClassName,
            innerContentClassName,
            children,
            target,
            withBorders = true,
            withPaddingInContent = true,
            collapseBtnStyle = {}
        } = this.props;

        const {isOpen} = this.state;

        return (
            <div>
                <div className={cx('targetWrapper', className)}>
                    <div className={cx('target', targetClassName)}>
                        {target}
                    </div>
                    <div className={styles.tooltipWrapper}>
                        <Tooltip content="More">
                            <button
                                className={cx(styles.toggleButton, {isOpen})}
                                onClick={this._handleCollapseArrowClick}
                                style={collapseBtnStyle}
                            >
                                {/* TODO: think about SVG sprites and css fill like here https://css-tricks.com/svg-sprites-use-better-icon-fonts/*/}
                                <ImgIcon icon={ImgIcons.sliderClosed} className={styles.closedIcon} />
                                <ImgIcon icon={ImgIcons.sliderClosedHover} className={styles.closedHoverIcon} />
                                <ImgIcon icon={ImgIcons.sliderOpen} className={styles.openIcon} />
                                <ImgIcon icon={ImgIcons.sliderOpenHover} className={styles.openHoverIcon} />
                            </button>
                        </Tooltip>
                    </div>
                </div>
                {
                    <div className={cx(
                        'contentWrapper',
                        {isOpen, withBorders, withPaddingInContent},
                        contentClassName
                    )}>
                        {/*<div*/}
                        {/*className={cx(styles.content, {isOpen})}*/}
                        {/*style={{*/}
                        {/*height: this.state.height + 'px',*/}
                        {/*overflow: this.state.isOverflowHidden ? 'hidden' : 'visible'*/}
                        {/*}}*/}
                        {/*>*/}
                        <div className={cx(styles.content, {isOpen})}>
                            <div className={cx(styles.innerContent, {withPaddingInContent}, innerContentClassName)}
                                 ref={element =>
                                 {
                                     this.content = element;
                                 }}>
                                {children}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
